import {resolveSelectedProperty} from './index';
import {selectablePropertyResolver} from '../utils';

export default function resolveProviderSelectedProperty(
	propertyValue,
	providerPropPath,
	componentRegistry,
	propertyDef
) {
	if (providerPropPath) {
		return resolveSelectedProperty(
			componentRegistry,
			selectablePropertyResolver,
			propertyValue.substring(0, propertyValue.length - providerPropPath.length),
			propertyDef
		);
	}
	return resolveSelectedProperty(
		componentRegistry,
		selectablePropertyResolver,
		propertyValue,
		propertyDef
	);
}
